import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Select } from 'antd';
import { AppSelectors } from '@redux/AppRedux';

const { Option } = Select;

const transformRegion = ({ regionID, name }) => ({
  key: regionID,
  value: regionID,
  label: name
});

function RegionSearch(props) {
  const { regions, value, onChange, ...restProps } = props;
  const [data, setData] = useState(regions.map(transformRegion));

  useEffect(() => {
    setData(regions.map(transformRegion));
  }, [regions]);

  return (
    <Select
      mode="multiple"
      style={{ width: '100%' }}
      placeholder="Regions"
      onChange={onChange}
      value={value}
      {...restProps}
    >
      {data.map(regionItem => (
        <Option
          key={regionItem.key}
          value={regionItem.value}
          title={regionItem.label}
        >
          {regionItem.label}
        </Option>
      ))}
    </Select>
  );
}

RegionSearch.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  regions: PropTypes.array
};

const mapStateToProps = state => ({
  regions: AppSelectors.selectRegions(state)
});

export default connect(
  mapStateToProps,
  {}
)(RegionSearch);
